import { useIsMobile } from 'hooks';
import { CommandCenterMobile } from './CommandCenterMobile';
import { CommandCenterDesktop } from './CommandCenterDesktop';

export const CommandCenter = (): JSX.Element => {
  const isMobile = useIsMobile();
  return isMobile ? <CommandCenterMobile /> : <CommandCenterDesktop />;
};
